import React from "react";
import styled, { keyframes } from "styled-components";

type InfiniteProgressProps = {
  isLoading: boolean;
};

const InfiniteProgress = (props: InfiniteProgressProps) => {
  const { isLoading } = props;

  return (
    <ProgressOuter visible={isLoading}>
      {isLoading && <ProgressInner />}
    </ProgressOuter>
  );
};

const loadingAnimation = keyframes`
  from {
    left: translateX(0);
  }

  to {
    left: 100%;
  }
`;

type ProgressOuterProps = {
  visible: boolean;
};

const ProgressOuter = styled.div<ProgressOuterProps>`
  height: 3px;
  background-color: ${({ theme }) => theme.colors.gray100};
  overflow: hidden;
  position: relative;
  width: 100%;

  opacity: ${({ visible }) => (visible ? 1 : 0)};
`;

const ProgressInner = styled.div`
  background-image: linear-gradient(
    to right,
    transparent 0%,
    ${({ theme }) => theme.colors.secondary} 50%,
    transparent 100%
  );
  height: 100%;
  width: 50%;
  position: absolute;
  left: 0;
  animation: ${loadingAnimation} 1.25s ease infinite;
`;

export default InfiniteProgress;
